// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__78ZMw","title":"Images45_title__26boZ","images":"Images45_images__2Q9ln"};